import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    // "offlineFirst": try even when the browser says it's offline – the service worker answers from its cache.
    queries: { staleTime: 30_000, refetchOnWindowFocus: true, networkMode: "offlineFirst" },
  },
});

/** Refetch all server data – the SPA equivalent of reloading the page after a change. */
export const refreshData = () => queryClient.invalidateQueries();
